import React from "react";

import { RouteComponentProps } from "@reach/router";
import { navigate } from "gatsby";

import { NavigationConstants } from "@assets/constants";
import { SpinnerPage } from "@components/index";

const MainServiceWeb = process.env.MainServiceWeb;

interface PrivateRouteProps extends RouteComponentProps {
  children?: React.ReactNode;
  component: typeof React.Component | React.FunctionComponent;
  hasAccess: boolean;
  isLoaded: boolean;
  loggedIn: boolean;
  mode?: NavigationConstants.PAGE_MODE;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  component: Component,
  hasAccess,
  isLoaded,
  loggedIn,
  ...rest
}) => {
  if (isLoaded && !loggedIn) {
    window.location.href = `${MainServiceWeb}/login`;
    return <SpinnerPage />;
  }

  if (isLoaded && !hasAccess) {
    navigate("/", { replace: true });
    return <SpinnerPage />;
  }

  return isLoaded ? (
    <Component {...rest}>{children}</Component>
  ) : (
    <SpinnerPage />
  );
};

export default PrivateRoute;
